import { ApiProperty } from "@nestjs/swagger";

export class PlaceListDto {
    placeListItemsId: number;
    storeConsumptionId: number;
    itemId: number;
    issuedQty: number;
    rackPosition: string;
    rackPositionId: number;
    palletCode: number;
    rackReserveCode: number;
    palletCapacity: number;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;
    reportingQty: number
}